import {bp} from '../core/namespace.js';

/*****************
 * bp.frontPageSearchForm
 */
$.extend(true, bp, {

  frontPageSearchForm: (function () {

    var opts = {}

    return {
      init: function (custom_opts) {
        custom_opts = typeof custom_opts !== 'undefined' ? custom_opts : {};
        $.extend(true, opts, custom_opts);

        $(".search-frontpage .input-group a").click(function () {
          $(this).parents('ul').siblings('button').html($(this).text() + ' <span class="caret"></span>');
          $($(this).parents('ul').data('target')).val($(this).data('value'));
        });
        // transform 'enter' into 'click'
        $(".search-frontpage .input-group a").on('keydown', function (e) {
          if (e.keyCode === 13) {
            $(this).trigger("click", true);
            e.preventDefault();
          }
        });

        // enter on display field is submit
        $("#id_cn").on('keydown', function (e) {
          if (e.keyCode === 13) {
            $('#search_data').submit();
          }
        });

        // On submit, collapse the multi-select #id_ups into a single
        // comma-separated hidden "ups" input. The homepage_search_redirect view
        // reads ups as one comma-separated string; without this join the
        // bootstrap-select posts repeated ups= params and all-but-one type is
        // dropped. (Restored: removed during the bp.js bundle refactor.)
        $("#search_data").on('submit', function () {
          const urlParams = $('#id_ups').val().join();
          $("<input />").attr("type", "hidden")
            .attr("name", "ups")
            .attr("value", urlParams)
            .attr("id", "id_ups")
            .appendTo("#search_data");
          $('#id_ups').remove();
          return true;
        });
      }
    }
  })()
});
